(function () {
  const OPEN_CLASS = 'bagveda-cart-open';
  let lockedScrollY = 0;
  let lastTrigger = null;

  const cartAddUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
  const cartChangeUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_change_url) || '/cart/change.js';
  const cartUpdateUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';
  const cartJsonUrl = () => {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return `${root}cart.js`;
  };

  const cartPathname = () => {
    const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    try {
      return new URL(cartUrl, window.location.origin).pathname.replace(/\/$/, '') || '/cart';
    } catch (error) {
      return '/cart';
    }
  };

  const jsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  const drawer = () => document.querySelector('[data-bagveda-cart-drawer]');

  const fitOverlayToViewport = () => {
    const overlay = drawer();
    if (!overlay) return;

    const viewport = window.visualViewport;
    const height = Math.round(viewport ? viewport.height : window.innerHeight);
    const offsetTop = Math.round(viewport ? viewport.offsetTop : 0);

    overlay.style.top = `${offsetTop}px`;
    overlay.style.height = `${height}px`;
    overlay.style.maxHeight = `${height}px`;
    overlay.style.bottom = 'auto';
  };

  const resetOverlayViewport = () => {
    const overlay = drawer();
    if (!overlay) return;
    overlay.style.top = '';
    overlay.style.height = '';
    overlay.style.maxHeight = '';
    overlay.style.bottom = '';
  };

  let viewportCleanup = null;

  const bindOverlayViewport = () => {
    fitOverlayToViewport();
    const viewport = window.visualViewport;

    if (viewport) {
      viewport.addEventListener('resize', fitOverlayToViewport);
      viewport.addEventListener('scroll', fitOverlayToViewport);
      viewportCleanup = () => {
        viewport.removeEventListener('resize', fitOverlayToViewport);
        viewport.removeEventListener('scroll', fitOverlayToViewport);
      };
      return;
    }

    window.addEventListener('resize', fitOverlayToViewport);
    viewportCleanup = () => window.removeEventListener('resize', fitOverlayToViewport);
  };

  const unbindOverlayViewport = () => {
    if (typeof viewportCleanup === 'function') {
      viewportCleanup();
      viewportCleanup = null;
    }
    resetOverlayViewport();
  };

  const WHATSAPP_BOTTOM = 'calc(160px + env(safe-area-inset-bottom, 0px))';
  let widgetObserver = null;

  const whatsappTargets = () =>
    [document.querySelector('div:has(> #whatsappIconWidget)'), document.getElementById('whatsappIconWidget')].filter(
      (element) => element instanceof HTMLElement
    );

  const restoreLiftedWidgets = () => {
    document.querySelectorAll('[data-bagveda-cart-lifted="true"]').forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      if (element.dataset.bagvedaCartBottom) {
        element.style.setProperty('bottom', element.dataset.bagvedaCartBottom);
      } else {
        element.style.removeProperty('bottom');
      }
      delete element.dataset.bagvedaCartLifted;
      delete element.dataset.bagvedaCartBottom;
    });
  };

  const liftWhatsAppWidget = (lift) => {
    if (!lift) {
      restoreLiftedWidgets();
      if (widgetObserver) {
        widgetObserver.disconnect();
        widgetObserver = null;
      }
      return;
    }

    restoreLiftedWidgets();
    whatsappTargets().forEach((element) => {
      element.dataset.bagvedaCartBottom = element.style.bottom || '';
      element.dataset.bagvedaCartLifted = 'true';
      element.style.setProperty('bottom', WHATSAPP_BOTTOM, 'important');
    });

    if (!widgetObserver) {
      widgetObserver = new MutationObserver(() => {
        if (!document.getElementById('whatsappIconWidget')) return;
        if (document.querySelector('[data-bagveda-cart-lifted="true"]')) return;
        liftWhatsAppWidget(true);
      });
      widgetObserver.observe(document.body, { childList: true });
    }
  };

  const LOGIN_PASS_SELECTOR = '#flexy-pass, dialog.flexy-pass-dialog';
  let loginPassObserver = null;
  let loginPassDialogObserver = null;
  let loginPassGuardTimer = null;

  const isCartOpen = () => document.documentElement.classList.contains(OPEN_CLASS);

  const dismissLoginPass = () => {
    if (!isCartOpen()) return;

    const dialog = document.querySelector(LOGIN_PASS_SELECTOR);
    const isVisible =
      dialog instanceof HTMLDialogElement && (dialog.open || dialog.classList.contains('visible'));

    if (isVisible && typeof window.closeFlexyPass === 'function') {
      window.closeFlexyPass();
    } else if (dialog instanceof HTMLDialogElement && dialog.open) {
      dialog.close();
      dialog.classList.remove('visible');
    }

    if (dialog) dialog.classList.remove('visible');

    const htmlOverflow = document.documentElement.style.overflow;
    if (htmlOverflow === 'hidden' || htmlOverflow === 'visible') {
      document.documentElement.style.removeProperty('overflow');
    }
  };

  const observeLoginPassDialog = (dialog) => {
    if (loginPassDialogObserver || !(dialog instanceof Element)) return;

    loginPassDialogObserver = new MutationObserver(() => {
      if (!isCartOpen()) return;
      if (!(dialog instanceof HTMLDialogElement)) return;
      if (dialog.open || dialog.classList.contains('visible')) dismissLoginPass();
    });
    loginPassDialogObserver.observe(dialog, {
      attributes: true,
      attributeFilter: ['open', 'class'],
    });
  };

  const nativeShowModal = HTMLDialogElement.prototype.showModal;
  if (!nativeShowModal.__bagvedaCartGuard) {
    const guardedShowModal = function (...args) {
      const result = nativeShowModal.apply(this, args);
      if (
        isCartOpen() &&
        (this.id === 'flexy-pass' || this.classList.contains('flexy-pass-dialog'))
      ) {
        window.requestAnimationFrame(() => {
          dismissLoginPass();
          window.setTimeout(dismissLoginPass, 0);
        });
      }
      return result;
    };
    guardedShowModal.__bagvedaCartGuard = true;
    HTMLDialogElement.prototype.showModal = guardedShowModal;
  }

  const installOpenPassGuard = () => {
    const original = window.openFlexyPass;
    if (typeof original !== 'function' || original.__bagvedaCartGuard) {
      return typeof original === 'function';
    }

    const guarded = function (...args) {
      if (isCartOpen()) return Promise.resolve();
      return original.apply(this, args);
    };
    guarded.__bagvedaCartGuard = true;
    window.openFlexyPass = guarded;
    return true;
  };

  const suppressLoginPass = (enable) => {
    if (!enable) {
      if (loginPassObserver) {
        loginPassObserver.disconnect();
        loginPassObserver = null;
      }
      if (loginPassDialogObserver) {
        loginPassDialogObserver.disconnect();
        loginPassDialogObserver = null;
      }
      if (loginPassGuardTimer) {
        window.clearInterval(loginPassGuardTimer);
        loginPassGuardTimer = null;
      }
      return;
    }

    dismissLoginPass();
    installOpenPassGuard();
    observeLoginPassDialog(document.querySelector(LOGIN_PASS_SELECTOR));

    if (!loginPassGuardTimer) {
      let attempts = 0;
      loginPassGuardTimer = window.setInterval(() => {
        attempts += 1;
        installOpenPassGuard();
        observeLoginPassDialog(document.querySelector(LOGIN_PASS_SELECTOR));
        dismissLoginPass();
        if (attempts >= 40 || !isCartOpen()) {
          window.clearInterval(loginPassGuardTimer);
          loginPassGuardTimer = null;
        }
      }, 500);
    }

    if (loginPassObserver) return;

    loginPassObserver = new MutationObserver((mutations) => {
      if (!isCartOpen()) return;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          const dialog =
            node.matches?.(LOGIN_PASS_SELECTOR) ? node : node.querySelector?.(LOGIN_PASS_SELECTOR);
          if (dialog) observeLoginPassDialog(dialog);
        });
      });

      dismissLoginPass();
    });
    loginPassObserver.observe(document.documentElement, { childList: true, subtree: true });
  };

  const lockScroll = () => {
    if (document.body.dataset.bagvedaCartScrollLocked === 'true') return;

    lockedScrollY = window.scrollY;
    document.body.dataset.bagvedaCartScrollLocked = 'true';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unlockScroll = () => {
    if (document.body.dataset.bagvedaCartScrollLocked !== 'true') return;

    document.body.dataset.bagvedaCartScrollLocked = 'false';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  };

  const syncDrawerState = (isOpen) => {
    const root = drawer();
    if (root) {
      root.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    if (isOpen) {
      lockScroll();
      bindOverlayViewport();
      liftWhatsAppWidget(true);
      suppressLoginPass(true);
      const panel = document.querySelector('[data-bagveda-cart-panel]');
      const closeButton = document.querySelector('[data-bagveda-cart-close]');
      window.requestAnimationFrame(() => {
        fitOverlayToViewport();
        (closeButton || panel)?.focus?.();
      });
      return;
    }

    suppressLoginPass(false);
    liftWhatsAppWidget(false);
    unbindOverlayViewport();
    unlockScroll();
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  };

  const openCart = (trigger) => {
    if (trigger instanceof Element) lastTrigger = trigger;
    document.documentElement.classList.add(OPEN_CLASS);
    syncDrawerState(true);
    ensureTimerLoop();
  };

  const closeCart = () => {
    document.documentElement.classList.remove(OPEN_CLASS);
    syncDrawerState(false);
    stopTimerLoop();
  };

  const isCartPage = () => {
    const template = document.getElementById('MainContent');
    return template?.getAttribute('data-template') === 'cart' || template?.classList.contains('cart');
  };

  const isCartTrigger = (element) => {
    if (!(element instanceof Element)) return false;
    if (element.closest('[data-bagveda-cart-drawer]')) return false;
    if (element.closest('form[action*="checkout"]')) return false;
    if (element.hasAttribute('data-bagveda-cart-open')) return true;
    if (element.closest('[data-bagveda-cart-open]')) return true;
    if (element.closest('a.action__cart')) return true;

    const link = element.closest('a[href]');
    if (!link) return false;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return false;

    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/$/, '') === cartPathname();
    } catch (error) {
      return false;
    }
  };

  const toggleNote = (event) => {
    const trigger = event.target.closest('[data-bagveda-cart-note-trigger]');
    if (!trigger) return;

    const panel = trigger.parentElement && trigger.parentElement.querySelector('[data-bagveda-cart-note-panel]');
    if (!panel) return;

    const isHidden = panel.hasAttribute('hidden');
    if (isHidden) {
      panel.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      panel.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }
  };

  const updateGiftWrap = async (event) => {
    const input = event.target.closest('[data-bagveda-cart-gift-wrap]');
    if (!input) return;

    const value = input.checked ? 'Yes' : '';
    try {
      await fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({
          attributes: {
            'Gift wrap': value,
          },
        }),
      });
    } catch (error) {
      input.checked = !input.checked;
    }
  };

  const publishCart = (cart, sections, sourceId) => {
    const scroll = document.querySelector('.bagveda-cart__scroll');
    const scrollTop = scroll ? scroll.scrollTop : 0;

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId,
          data: {
            itemCount: cart && cart.item_count,
            source: sourceId,
            sections,
          },
        },
      })
    );

    window.requestAnimationFrame(() => {
      const next = document.querySelector('.bagveda-cart__scroll');
      if (next) next.scrollTop = scrollTop;
    });
  };

  const removeLine = async (event) => {
    const button = event.target.closest('[data-bagveda-line-remove]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const line = Number(button.getAttribute('data-line'));
    if (!line) return;

    const sectionEl = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = sectionEl && sectionEl.dataset.sectionId;
    const row = button.closest('.bagveda-cart__line');

    button.disabled = true;
    if (row) row.classList.add('is-removing');

    try {
      const response = await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({
          line,
          quantity: 0,
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        button.disabled = false;
        if (row) row.classList.remove('is-removing');
        return;
      }

      const data = await response.json();
      if (data.errors) {
        button.disabled = false;
        if (row) row.classList.remove('is-removing');
        return;
      }

      publishCart(data, data.sections, 'bagveda-cart-line');
    } catch (error) {
      button.disabled = false;
      if (row) row.classList.remove('is-removing');
    }
  };

  const addUpsell = async (event) => {
    const button = event.target.closest('[data-bagveda-upsell-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const sectionEl = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = sectionEl && sectionEl.dataset.sectionId;
    const rewardTier = button.getAttribute('data-bagveda-reward-tier');
    const payload = {
      id: Number(variantId),
      quantity: 1,
      sections: sectionId,
      sections_url: window.location.pathname,
    };

    if (rewardTier) {
      payload.properties = { _bagveda_reward: rewardTier };
    }

    button.disabled = true;

    try {
      const addResponse = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify(payload),
      });

      if (!addResponse.ok) {
        button.disabled = false;
        return;
      }

      const addData = await addResponse.json();
      const cart = await fetch(cartJsonUrl())
        .then((res) => res.json())
        .catch(() => null);

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'bagveda-cart-upsell',
            data: {
              itemCount: cart && cart.item_count,
              variantId,
              source: 'bagveda-cart-upsell',
              sections: addData.sections,
            },
          },
        })
      );
    } catch (error) {
      button.disabled = false;
    }
  };

  const padUnit = (value, suffix) => `${String(value).padStart(2, '0')}${suffix}`;

  const endForTimer = (root) => {
    const duration = Number(root.getAttribute('data-duration') || 0);
    const storageKey = root.getAttribute('data-storage-key');
    if (duration <= 0 || !storageKey) return 0;

    let end = 0;
    try {
      end = Number(window.localStorage.getItem(storageKey) || 0);
    } catch (error) {
      end = 0;
    }

    if (!end || end < Date.now()) {
      end = Date.now() + duration * 1000;
      try {
        window.localStorage.setItem(storageKey, String(end));
      } catch (error) {
        // Ignore private-mode storage failures.
      }
    }

    return end;
  };

  let timerIntervalId = null;

  const renderTimers = () => {
    document.querySelectorAll('[data-bagveda-cart-timer]').forEach((root) => {
      const minEl = root.querySelector('[data-bagveda-timer-min]');
      const secEl = root.querySelector('[data-bagveda-timer-sec]');
      if (!minEl || !secEl) return;

      const remaining = Math.max(0, Math.floor((endForTimer(root) - Date.now()) / 1000));
      minEl.textContent = padUnit(Math.floor(remaining / 60), 'Min');
      secEl.textContent = padUnit(remaining % 60, 'Sec');
    });
  };

  const stopTimerLoop = () => {
    if (timerIntervalId == null) return;
    window.clearInterval(timerIntervalId);
    timerIntervalId = null;
  };

  const ensureTimerLoop = () => {
    const timers = document.querySelectorAll('[data-bagveda-cart-timer]');
    if (!timers.length) {
      stopTimerLoop();
      return;
    }

    renderTimers();

    if (timerIntervalId != null) return;

    timerIntervalId = window.setInterval(() => {
      const activeTimers = document.querySelectorAll('[data-bagveda-cart-timer]');
      if (!activeTimers.length || !document.documentElement.classList.contains(OPEN_CLASS)) {
        stopTimerLoop();
        return;
      }

      renderTimers();

      let hasTimeLeft = false;
      activeTimers.forEach((root) => {
        if (endForTimer(root) > Date.now()) {
          hasTimeLeft = true;
        }
      });

      if (!hasTimeLeft) {
        stopTimerLoop();
      }
    }, 1000);
  };

  const toggleCoupons = (event) => {
    const trigger = event.target.closest('[data-bagveda-coupons-toggle]');
    if (!trigger) return;

    const extra = trigger.closest('[data-bagveda-coupons]') && trigger.closest('[data-bagveda-coupons]').querySelector('[data-bagveda-coupon-extra]');
    if (!extra) return;

    const isHidden = extra.hasAttribute('hidden');
    if (isHidden) {
      extra.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      extra.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }
  };

  let removingRewards = false;

  const removeIneligibleRewards = async () => {
    if (removingRewards) return;

    const node = document.querySelector('[data-bagveda-reward-removals]');
    const raw = node && node.getAttribute('data-bagveda-reward-removals');
    if (!raw) return;

    const keys = raw.split(',').map((key) => key.trim()).filter(Boolean);
    if (!keys.length) return;

    const sectionEl = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = sectionEl && sectionEl.dataset.sectionId;
    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    removingRewards = true;

    try {
      const response = await fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({
          updates,
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) return;

      const data = await response.json();
      const cart = await fetch(cartJsonUrl())
        .then((res) => res.json())
        .catch(() => data);

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'bagveda-cart-rewards',
            data: {
              itemCount: cart && cart.item_count,
              source: 'bagveda-cart-rewards',
              sections: data.sections,
            },
          },
        })
      );
    } catch (error) {
      // Leave gifts in place if the update fails.
    } finally {
      removingRewards = false;
    }
  };

  const ADD_OPEN_SOURCES = {
    'product-form-component': true,
    'bagveda-card-atc': true,
    'bagveda-wishlist': true,
    'bagveda-wishlist-move': true,
  };

  const shouldOpenCartOnAdd = (event) => {
    const detail = event.detail || {};
    const data = detail.data || {};
    if (data.didError) return false;

    const source = data.source || detail.sourceId;
    if (!ADD_OPEN_SOURCES[source]) return false;

    const itemCount = data.itemCount ?? detail.resource?.item_count;
    if (itemCount === 0) return false;

    return Boolean(drawer());
  };

  ensureTimerLoop();
  removeIneligibleRewards();
  document.addEventListener(
    'cart:update',
    (event) => {
      if (event.detail && event.detail.sourceId === 'bagveda-cart-rewards') return;
      window.setTimeout(removeIneligibleRewards, 80);
      if (shouldOpenCartOnAdd(event)) openCart();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const closeTrigger = event.target.closest('[data-bagveda-cart-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeCart();
        return;
      }

      if (isCartTrigger(event.target)) {
        if (!drawer()) return;

        event.preventDefault();
        event.stopPropagation();
        openCart(event.target.closest('a, button') || event.target);
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-bagveda-line-remove]')) {
      removeLine(event);
      return;
    }

    toggleNote(event);
    toggleCoupons(event);
    addUpsell(event);
  });

  document.addEventListener('change', updateGiftWrap);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!document.documentElement.classList.contains(OPEN_CLASS)) return;
    closeCart();
  });

  document.addEventListener('bagveda-cart:open', () => openCart());
  document.addEventListener('bagveda-cart:close', closeCart);

  if (isCartPage()) {
    openCart();
  } else if (document.documentElement.classList.contains(OPEN_CLASS)) {
    suppressLoginPass(true);
  }
})();
